export const galleryImages = [
    {
      url: '/assets/photo1.jpeg',
      alt: 'Team Meeting'
    },
    {
      url: '/assets/photo2.jpeg',
      alt: 'Lab Work'
    },
    {
      url: '/assets/photo3.jpeg',
      alt: 'Office Environment'
    },
    {
      url: '/assets/photo4.jpeg',
      alt: 'Team Building'
    },
    {
      url: '/assets/photo5.jpeg',
      alt: 'Team Building'
    },
    {
      url: '/assets/photo6.jpeg',
      alt: 'Team Building'
    },
    {
      url: '/assets/photo7.jpeg',
      alt: 'Team Building'
    },
    {
      url: '/assets/photo8.jpeg',
      alt: 'Team Building'
    },
    {
      url: '/assets/photo9.jpeg',
      alt: 'Team Building'
    },
    {
      url: '/assets/photo10.jpeg',
      alt: 'Team Building'
    },
    {
      url: '/assets/photo11.jpeg',
      alt: 'Team Building'
    },
    {
      url: '/assets/photo12.jpeg',
      alt: 'Team Building'
    }
  ];